import { StoredMeasurement, StoredSpot } from '../types/Individualization'
import { loadClipPath } from './loadClipPath'

export function getSpotRealSizesInMm(
    spot: StoredSpot,
    measurement: StoredMeasurement | null
): { width: string; height: string } | null {
    if (
        !measurement?.orientation ||
        !measurement.real_length ||
        !measurement.length
    ) {
        return null
    }

    const measured = measurement.real_length
    const referenceSize = measurement.length

    if (measured <= 0 || referenceSize <= 0) {
        return null
    }

    const ratio = measured / referenceSize
    const element = loadClipPath(spot)

    return {
        width: (element.getScaledWidth() * ratio).toFixed(2).replace('.', ','),
        height: (element.getScaledHeight() * ratio).toFixed(2).replace('.', ','),
    }
}
